const $$splitComponentImporter = () => import('/app/frontend/src/routes/_app/developer/demo/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_app/developer/demo/')({
  staticData: {
    breadCrumb: 'Demo'
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});